/**
 * Phone preview for testing (V19.19, computer layout part 4).
 *
 * On a computer, Settings > Display & Layout > "Phone preview (for testing)"
 * (off by default, kept on this computer only) shows a Computer | Phone
 * switch in the top bar. Phone shows this same app, signed in as you, inside
 * a phone-sized frame - 360, 390 or 430 wide - so the phone layout can be
 * checked without a phone.
 *
 * THE FRAMED COPY IS A GUEST. It shares this computer's sign-in, so it must
 * never renew the sign-in itself (two copies renewing at once could each
 * throw out the other's pass), never register the offline worker, and never
 * play the intro. isFramedPreview() is how each of those places knows. The
 * frame is recognised by its name, which stays with it as the copy inside
 * moves between screens.
 */
import { safeGet, safeSet, safeRemove } from "./safeStorage";

export const PREVIEW_FRAME_NAME = "xel-phone-preview";
export const PREVIEW_KEY = "xelPhonePreview";
export const PREVIEW_CHANGED = "xel-phone-preview-changed";
export const PREVIEW_SIZES = [
  { w: 360, h: 780 },
  { w: 390, h: 844 },
  { w: 430, h: 932 },
];

export function isFramedPreview() {
  try {
    return typeof window !== "undefined" && window.self !== window.top &&
      window.name === PREVIEW_FRAME_NAME;
  } catch {
    return false;
  }
}

export const previewEnabled = () => safeGet(PREVIEW_KEY) === "1";

export function setPreviewEnabled(on) {
  if (on) safeSet(PREVIEW_KEY, "1");
  else safeRemove(PREVIEW_KEY);
  try { window.dispatchEvent(new Event(PREVIEW_CHANGED)); } catch { /* noop */ }
}

/** How small the phone must be drawn to fit the space it has (never bigger). */
export function previewScale(size, availableHeight) {
  const h = Number(size && size.h) || 844;
  const room = Number(availableHeight) || 0;
  if (room <= 0) return 1;
  return Math.max(0.4, Math.min(1, room / h));
}
